export default "<div class=\"cygov-loader\">\n  <div class=\"spinner\"></div>\n</div>\n"